/* eslint-disable react/jsx-no-useless-fragment */
import { Breadcrumb, FlexProps } from '@chakra-ui/react';
import { IBreadcrumbItem } from '@monetize/types/app';
import { FC, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { MFlex } from './chakra';
import { MBackButton } from './MBackButton';

interface MBreadcrumbProps {
  items: IBreadcrumbItem[];
  hasBackButton?: boolean;
  containerProps?: FlexProps;
}

export const MBreadcrumb: FC<MBreadcrumbProps> = ({
  items,
  hasBackButton,
  containerProps,
}: MBreadcrumbProps) => {
  return (
    <MFlex alignItems="center" {...containerProps}>
      {hasBackButton && <MBackButton />}

      <Breadcrumb.Root mt="0.5">
        <Breadcrumb.List>
          {items.map(
            ({ route, isCurrentPage, label, renderItem, linkProps }, index) => (
              <Fragment key={index}>
                <Breadcrumb.Item>
                  <>
                    {renderItem ? (
                      renderItem()
                    ) : isCurrentPage ? (
                      <Breadcrumb.CurrentLink
                        fontSize="md"
                        fontWeight="600"
                        lineHeight={1.2}
                      >
                        {label}
                      </Breadcrumb.CurrentLink>
                    ) : (
                      <Breadcrumb.Link
                        fontSize="md"
                        fontWeight="600"
                        lineHeight={1.2}
                        {...linkProps}
                        asChild
                      >
                        <Link to={route ?? ''}>{label}</Link>
                      </Breadcrumb.Link>
                    )}
                  </>
                </Breadcrumb.Item>
                {/* v2's Breadcrumb drew a "/" between items itself; v3 only
                    renders the separators it's given. */}
                {index < items.length - 1 && (
                  <Breadcrumb.Separator>/</Breadcrumb.Separator>
                )}
              </Fragment>
            ),
          )}
        </Breadcrumb.List>
      </Breadcrumb.Root>
    </MFlex>
  );
};
